import { render, staticRenderFns } from "./tag-edit.vue?vue&type=template&id=e04ecf5a&scoped=true&"
import script from "./tag-edit.vue?vue&type=script&lang=js&"
export * from "./tag-edit.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/i-switch.less?vue&type=style&index=0&id=e04ecf5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04ecf5a",
  null
  
)

component.options.__file = "tag-edit.vue"
export default component.exports